import { Component } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { Input } from '@angular/core';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.css'],
})
export class LineChartComponent {
  @Input() chartData: ChartConfiguration<'line'>['data'] | undefined;
  @Input() yAxisTitle: any;
  @Input() xAxisTitle: any;

  get barChartOptions(): ChartConfiguration<'line'>['options'] {
    return {
      responsive: true,
      scales: {
        x: {
          display: true,
          ticks: {
            // color: '#0058e9',
          },
          grid: {
            display: false,
          },
          title: {
            display: true,
            text: this.xAxisTitle,
            font: {
              size: 12,
            },
            color: '#0058e9',
          },
        },
        y: {
          display: true,
          ticks: {
            stepSize: 0.1,
            display: true,
          },
          grid: {
            display: true,
          },
          title: {
            display: true,
            text: this.yAxisTitle,
            font: {
              size: 12,
            },
            color: '#0058e9',
          },
        },
      },
      plugins: {
        legend: {
          display: true,
        },
      },
    };
  }
}
